import request from '@/utils/request'


// 查询用户血糖测量记录列表
export function listBloodSugar(query) {
  return request({
    url: '/joe/user-blood-sugar/list',
    method: 'get',
    params: query
  })
}

// 查询用户血糖测量记录分页
export function pageBloodSugar(query) {
  return request({
    url: '/joe/user-blood-sugar/page',
    method: 'get',
    params: query
  })
}

// 查询用户血糖测量记录详细
export function getBloodSugar(data) {
  return request({
    url: '/joe/user-blood-sugar/detail',
    method: 'get',
    params: data
  })
}

// 新增用户血糖测量记录
export function addBloodSugar(data) {
  return request({
    url: '/joe/user-blood-sugar/add',
    method: 'post',
    data: data
  })
}

// 修改用户血糖测量记录
export function updateBloodSugar(data) {
  return request({
    url: '/joe/user-blood-sugar/edit',
    method: 'post',
    data: data
  })
}

// 删除用户血糖测量记录
export function delBloodSugar(data) {
  return request({
    url: '/joe/user-blood-sugar/delete',
    method: 'post',
    data: data
  })
}
